import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import onboardingInfoBox from 'contest/components/onboarding-prompts/onboardingInfoBox';

export default onboardingInfoBox('new-designs', () => (
    <div className="info-box__content">
        <div className="info-box__title">
            <FormattedMessage id="infobox_title" />
        </div>
        <FormattedHTMLMessage id="infobox_text" />
    </div>
));



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/NewDesignsInfoBox.js